import { useTheme } from '@mui/material/styles'
import { useMediaQuery } from '@mui/material'

function Employment () {
  const theme = useTheme()
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'))

  return (
      <article
          style={{
            borderTop: '1px solid ' + theme.palette.lightGrey,
            display: 'flex',
            flexDirection: 'column',
            gap: '40px'
          }}
        >
          <h2
            style={{
              color: theme.palette.darkGrey,
              paddingTop: '28px'
            }}
          >
            Employment
          </h2>

          {/* UHN */}
          <article>
            {/* Employer */}
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '16px',
                marginBottom: '8px',
                ...isMediumScreen && { flexDirection: 'column-reverse', gap: '4px' },
              }}
            >
              <p
                style={{
                  color: theme.palette.darkGrey,
                  ...isMediumScreen && { width: '100%' },
                }}
              >
                <a href="https://uhndata.io/" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
                  <strong>Data Aggregation, Translation, and Architecture Team ↗</strong>
                </a>
                <br/>
                University Health Network
                <br/>
                Toronto, Ontario
              </p>
              <p style={{ color: theme.palette.darkGrey }}>
                <strong>2020 - present</strong>
              </p>
            </section>
            {/* Positions */}
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px'
              }}
            >
              <ul style={{ color: theme.palette.darkGrey }}>
                <li>
                  <p
                    style={{
                      color: theme.palette.darkGrey,
                      fontSize: '16px'
                    }}
                  >
                    Senior Manager
                  </p>
                </li>
              </ul>
              <p
                style={{
                  color: theme.palette.darkGrey,
                  fontSize: '16px',
                  textWrapMode: 'nowrap'
                }}
              >
                since 2024
              </p>
            </section>
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px'
              }}
            >
              <ul style={{ color: theme.palette.darkGrey }}>
                <li>
                  <p
                    style={{
                      color: theme.palette.darkGrey,
                      fontSize: '16px'
                    }}
                  >
                    IT / IM Manager
                  </p>
                </li>
              </ul>
              <p
                style={{
                  color: theme.palette.darkGrey,
                  fontSize: '16px',
                  textWrapMode: 'nowrap'
                }}
              >
                2020 - 2023
              </p>
            </section>
          </article>

          {/* CCM */}
          <article>
            {/* Employer */}
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '16px',
                marginBottom: '8px',
                ...isMediumScreen && { flexDirection: 'column-reverse', gap: '4px' },
              }}
            >
              <p
                style={{
                  color: theme.palette.darkGrey,
                  ...isMediumScreen && { width: '100%' },
                }}
              >
                <a href="https://ccm.sickkids.ca/" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
                  <strong>Centre for Computational Medicine ↗</strong>
                </a>
                <br/>
                SickKids Hospital
                <br/>
                Toronto, Ontario
              </p>
              <p style={{ color: theme.palette.darkGrey }}>
                <strong>2016 - 2020</strong>
              </p>
            </section>
            {/* Positions */}
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px'
              }}
            >
              <ul style={{ color: theme.palette.darkGrey }}>
                <li>
                  <p
                    style={{
                      color: theme.palette.darkGrey,
                      fontSize: '16px'
                    }}
                  >
                    Software Dev. Manager
                  </p>
                </li>
              </ul>
              <p
                style={{
                  color: theme.palette.darkGrey,
                  fontSize: '16px',
                  textWrapMode: 'nowrap'
                }}
              >
                2020
              </p>
            </section>
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px'
              }}
            >
              <ul style={{ color: theme.palette.darkGrey }}>
                <li>
                  <p
                    style={{
                      color: theme.palette.darkGrey,
                      fontSize: '16px'
                    }}
                  >
                    Senior Programmer / Analyst
                  </p>
                </li>
              </ul>
              <p
                style={{
                  color: theme.palette.darkGrey,
                  fontSize: '16px',
                  textWrapMode: 'nowrap'
                }}
              >
                2018 - 2019
              </p>
            </section>
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px'
              }}
            >
              <ul style={{ color: theme.palette.darkGrey }}>
                <li>
                  <p
                    style={{
                      color: theme.palette.darkGrey,
                      fontSize: '16px'
                    }}
                  >
                    Bioinformatician
                  </p>
                </li>
              </ul>
              <p
                style={{
                  color: theme.palette.darkGrey,
                  fontSize: '16px',
                  textWrapMode: 'nowrap'
                }}
              >
                2016 - 2018
              </p>
            </section>
          </article>

          {/* Biobank */}
          <article>
            {/* Employer */}
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '16px',
                marginBottom: '8px',
                ...isMediumScreen && { flexDirection: 'column-reverse', gap: '4px' },
              }}
            >
              <p
                style={{
                  color: theme.palette.darkGrey,
                  ...isMediumScreen && { width: '100%' },
                }}
              >
                <a href="https://theheartcentrebiobank.com/" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
                  <strong>Heart Centre Biobank ↗</strong>
                </a>
                <br/>
                SickKids Hospital
                <br/>
                Toronto, Ontario
              </p>
              <p style={{ color: theme.palette.darkGrey }}>
                <strong>2012 - 2016</strong>
              </p>
            </section>
            {/* Positions */}
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px'
              }}
            >
              <ul style={{ color: theme.palette.darkGrey }}>
                <li>
                  <p
                    style={{
                      color: theme.palette.darkGrey,
                      fontSize: '16px'
                    }}
                  >
                    Bioinformatician
                  </p>
                </li>
              </ul>
              <p
                style={{
                  color: theme.palette.darkGrey,
                  fontSize: '16px',
                  textWrapMode: 'nowrap'
                }}
              >
                2015 - 2016
              </p>
            </section>
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px'
              }}
            >
              <ul style={{ color: theme.palette.darkGrey }}>
                <li>
                  <p
                    style={{
                      color: theme.palette.darkGrey,
                      fontSize: '16px'
                    }}
                  >
                    Bioinformatics Analyst
                  </p>
                </li>
              </ul>
              <p
                style={{
                  color: theme.palette.darkGrey,
                  fontSize: '16px',
                  textWrapMode: 'nowrap'
                }}
              >
                2013 - 2015
              </p>
            </section>
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px'
              }}
            >
              <ul style={{ color: theme.palette.darkGrey }}>
                <li>
                  <p
                    style={{
                      color: theme.palette.darkGrey,
                      fontSize: '16px'
                    }}
                  >
                    Research Technologist
                  </p>
                </li>
              </ul>
              <p
                style={{
                  color: theme.palette.darkGrey,
                  fontSize: '16px',
                  textWrapMode: 'nowrap'
                }}
              >
                2012 - 2013
              </p>
            </section>
          </article>

          {/* Dalla Lana */}
          <article>
            {/* Employer */}
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '16px',
                marginBottom: '8px',
                ...isMediumScreen && { flexDirection: 'column-reverse', gap: '4px' },
              }}
            >
              <p
                style={{
                  color: theme.palette.darkGrey,
                  ...isMediumScreen && { width: '100%' },
                }}
              >
                <a href="https://www.dlsph.utoronto.ca/" target="blank" style={{ color: 'inherit', textDecoration: 'none' }}>
                  <strong>Dalla Lana School of Public Health ↗</strong>
                </a>
                <br/>
                University of Toronto
                <br/>
                Toronto, Ontario
              </p>
              <p style={{ color: theme.palette.darkGrey }}>
                <strong>2012</strong>
              </p>
            </section>
            {/* Positions */}
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px'
              }}
            >
              <ul style={{ color: theme.palette.darkGrey }}>
                <li>
                  <p
                    style={{
                      color: theme.palette.darkGrey,
                      fontSize: '16px'
                    }}
                  >
                    Research Student
                  </p>
                </li>
              </ul>
              <p
                style={{
                  color: theme.palette.darkGrey,
                  fontSize: '16px',
                  textWrapMode: 'nowrap'
                }}
              >
                2012
              </p>
            </section>
          </article>

          {/* Toronto Western */}
          <article>
            {/* Employer */}
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '16px',
                marginBottom: '8px',
                ...isMediumScreen && { flexDirection: 'column-reverse', gap: '4px' },
              }}
            >
              <p
                style={{
                  color: theme.palette.darkGrey,
                  ...isMediumScreen && { width: '100%' },
                }}
              >
                <strong>Liver Centre</strong>
                <br/>
                Toronto Western Hospital
                <br/>
                Toronto, Ontario
              </p>
              <p style={{ color: theme.palette.darkGrey }}>
                <strong>2011</strong>
              </p>
            </section>
            {/* Positions */}
            <section
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px'
              }}
            >
              <ul style={{ color: theme.palette.darkGrey }}>
                <li>
                  <p
                    style={{
                      color: theme.palette.darkGrey,
                      fontSize: '16px'
                    }}
                  >
                    Research Student
                  </p>
                </li>
              </ul>
              <p
                style={{
                  color: theme.palette.darkGrey,
                  fontSize: '16px',
                  textWrapMode: 'nowrap'
                }}
              >
                2011
              </p>
            </section>
          </article>

        </article>
  )
}

export default Employment
